"use client";

import { CaretLeft } from "@phosphor-icons/react";
import Skeleton from "../Skeleton";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "./BreadcrumbItem";

interface BreadCrumbProps {
  page: "results" | "detail";
}

export default function BreadCrumbSkeleton({ page }: BreadCrumbProps) {
  return (
    <Breadcrumb className="px-2">
      <BreadcrumbList>
        <BreadcrumbItem>
          <Skeleton className="w-20 h-3 rounded-full" />
        </BreadcrumbItem>
        <BreadcrumbSeparator>
          <CaretLeft weight="light" />
        </BreadcrumbSeparator>
        <BreadcrumbItem>
          <Skeleton className="w-20 h-3 rounded-full" />
        </BreadcrumbItem>
        {page === "detail" && (
          <>
            <BreadcrumbSeparator>
              <CaretLeft weight="light" />
            </BreadcrumbSeparator>
            <BreadcrumbItem>
              <Skeleton className="w-20 h-3 rounded-full" />
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
